import Event from 'base/event'
import Hub from 'base/hub'
import autotrack from './autotrack'
import attentive from './attentive'
import builder from './builder'
import setupFacebook, { loadFacebook } from './facebook'
import googleTagManager from './google_tag_manager'
import sift from './sift'
import pixlee from './pixlee'
import oneTrust, { getIsTargettingActive } from './one_trust'
import wunderkind from './wunderkind'

let HAVE_TRACKERS_BEEN_LOADED = false

const loadTargettingTrackers = () => {
  HAVE_TRACKERS_BEEN_LOADED = true

  setupFacebook()

  Hub.sub(
    Event.App.LOAD,
    () => {
      setTimeout(() => {
        loadFacebook()
        builder()
      }, 4200)
    },
    { late: true },
  )
}

export default function () {
  autotrack()

  Hub.sub(Event.OneTrust.PREFERENCES_SET, () => {
    googleTagManager()

    if (getIsTargettingActive() && !HAVE_TRACKERS_BEEN_LOADED) {
      loadTargettingTrackers()
    }
  })

  oneTrust()

  sift()

  Hub.sub(
    Event.App.POST_CRITICAL,
    () => {
      attentive()
      pixlee()
    },
    { late: true },
  )

  Hub.sub(
    Event.App.FIRST_INTERACTION,
    () => {
      wunderkind()
    },
    { late: true },
  )
}
